<ng-template #horizontalLayout>
  <mat-toolbar class="navTerms">
    <mat-select (change)="parentChange($event)" [(value)]="parentSelected" placeholder="{{placeholder}}"
                class="navTerms__years" *ngIf="navBarItems.length > 1">
      <ng-container *ngFor="let item of navBarItems">
        <mat-option [value]="item">{{item.text}}</mat-option>
      </ng-container>
    </mat-select>
    <h4 *ngIf="navBarItems.length == 1">
      {{navBarItems[0].text}}
    </h4>
    <ng-container *ngFor="let item of navBarItems">
      <ul [attr.data-year]="item.value" [ngClass]="{'hide': parentSelected != item}" class="navTerms__terms hide">
        <ng-container *ngFor="let child of item.children">
          <li *ngIf="child">
            <a [routerLink]="child.route"
               routerLinkActive="active">{{child.text}}</a>
          </li>
        </ng-container>
      </ul>
    </ng-container>
  </mat-toolbar>
</ng-template>

<ng-container *ngIf="verticalLayout; else horizontalLayout">
  <div class="vertical-layout">
    <mat-select (valueChange)="parentChange($event)" [(value)]="parentSelected" placeholder="{{placeholder}}"
                class="navTerms__years" *ngIf="navBarItems.length > 1">
      @for (item of navBarItems; track $index) {
        <ng-container >
          <mat-option [value]="item">{{item.text}}</mat-option>
        </ng-container>
      }
    </mat-select>
    <h4 *ngIf="navBarItems.length == 1">
      {{navBarItems[0].text}}
    </h4>
    <!-- @for ( periodo of navBarItems; track $index) {} -->
    <ng-container >
      <ul [attr.data-year]="parentSelected.value" [ngClass]="{'hide': parentSelected == periodo}" class="navTerms__terms hide">
        @for (child of parentSelected.children; track $index) {
          <ng-container >
            <li *ngIf="child">
              <a [routerLink]="child.route"
                 routerLinkActive="active">{{child.text}}</a>
            </li>
          </ng-container>
        }
      </ul>
    </ng-container>
  </div>
</ng-container>
